import React from "react";
import { Modal } from "antd";

const DeleteConfirm = ({
  children,
  title = "Are you sure you want to delete this record?",
  description,
  content,
  onConfirm,
  onCancel,
  okText = "Delete",
  cancelText = "Cancel",
  ...modalProps
}) => {
  const child = React.Children.only(children);

  const handleClick = (event) => {
    event?.stopPropagation?.();
    child.props?.onClick?.(event);
    if (event?.defaultPrevented) return;

    Modal.confirm({
      ...modalProps,
      title,
      content: content ?? description,
      okText,
      cancelText,
      okType: modalProps.okType || "danger",
      onOk: onConfirm,
      onCancel,
    });
  };

  return React.cloneElement(child, { onClick: handleClick });
};

export default DeleteConfirm;
